import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import draftTypes from 'constants/draftTypes';
import actionTypes from 'constants/actionTypes';

import Button from 'modules/_shared/components/Buttons';

import { useAddDraftInvestorModal } from '../context/AddDraftInvestorModalContext';

const AddDraftInvestorModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useAddDraftInvestorModal();

  const isCapitalIncreaseDraft =
    data.draftType === draftTypes.DRAFT_CAPITAL_INCREASE;

  const isNameMissing = !data.name;
  const requiresContributionDate = [
    draftTypes.DRAFT_CONVERTIBLE_NOTE,
    draftTypes.DRAFT_SAFE,
  ].includes(data.draftType);
  const isContributionDateMissing =
    requiresContributionDate && !data.contributionDate;
  const isHoldingClassMissing =
    isCapitalIncreaseDraft && !data.selectedHoldingClass;

  const isDisabled =
    isNameMissing || isContributionDateMissing || isHoldingClassMissing;

  const translationSuffix = isCapitalIncreaseDraft ? '.FORCED' : '';

  const buttonText =
    data.modalActionType === actionTypes.EDIT
      ? t(`EditInvestor${translationSuffix}`)
      : t(`AddInvestor${translationSuffix}`);

  return (
    <>
      <Modal.Footer>
        <Button onClick={actions.handleSaveDraftInvestor} disabled={isDisabled}>
          <span>{buttonText}</span>
        </Button>
      </Modal.Footer>
    </>
  );
};

export default AddDraftInvestorModalFooter;
